module.exports = __webpack_public_path__ + "static/media/placeholder-person.b9a8916a.jpeg";